module.exports = __webpack_public_path__ + "static/media/gal-3.d37431c4.jpeg";